import React, { FC } from 'react';
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { CanGoBack } from '../../models/CanGoBack';
import { SettingSummaryField } from '../settingFields/SettingSummaryField';

interface SummaryFormProps extends CanGoBack {
    categoryId?: number;
}
export const SummaryForm: FC<SummaryFormProps> = ({ categoryId = undefined, onBack }) => {
    const { translate } = useLocale();

    return <div className="pt-3 pr-3 h-full relative overflow-hidden" style={{ height: "501px" }}>
        <div className="flex flex-col overflow-auto" style={{ height: '87%' }}>
            <div className="pb-3">
                <SettingSummaryField accessor={"displayName"} displayName={translate.byKey(TranslationKeys.displayName)}></SettingSummaryField>
            </div>
            <div className="pb-3">
                <SettingSummaryField accessor={"description"} displayName={translate.byKey(TranslationKeys.description)}></SettingSummaryField>
            </div>

            {categoryId
                ? null
                : <div className="pb-3">
                    <SettingSummaryField accessor={"copyOfName"} displayName={translate.byKey(TranslationKeys.copyOf)}></SettingSummaryField>
                </div>
            }
            {/* <div className="pb-3">
                <SettingSummaryField accessor={"singleOwner"} displayName={translate.byKey(TranslationKeys.singleOwner)}></SettingSummaryField>
            </div>
            <div className="pb-3">
                <SettingSummaryField accessor={"autoIdNumber"} displayName={translate.byKey(TranslationKeys.autoGenerateIdNumber)}></SettingSummaryField>
            </div> */}
            <div className="pb-3">
                <SettingSummaryField accessor={"fields"} displayName={translate.byKey(TranslationKeys.fields)}></SettingSummaryField>
            </div>
        </div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="secondary secondary-inverse py-1 px-5"
                    type="button" onClick={onBack}>
                    {translate.byKey(TranslationKeys.back)}
                </button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className="secondary secondary-enabled py-1 px-5"
                    type="submit">
                    {translate.byKey(TranslationKeys.submit)}
                </button>
            </div>
        </div>
    </div>;
};
